<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="600px"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form :model="form" ref="form" label-width="100px" :rules="rules">
          <!-- <el-form-item label="头像" prop="HeadImg" class="Describe">
            <el-upload
              class="avatar-uploader"
              :action="$rootUrl + `/Base_Manage/Upload/UploadFileByForm`"
              :headers="{
                Authorization: token,
              }"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
                v-if="form.HeadImg"
                fit="contain"
                class="HeadImg"
                :src="form.HeadImg"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item> -->
          <el-form-item label="供应商编号" prop="Code">
            <el-input
              v-model="form.Code"
              placeholder="供应商编号自动生成"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="供应商名称" prop="Name">
            <el-input
              v-model="form.Name"
              placeholder="请输入供应商名账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="供应商类型" prop="Type">
            <SelectDicValue
              ref="SelectDicValue"
              code="SupplierType"
              v-model="form.Type"
            ></SelectDicValue>
          </el-form-item>
          <el-form-item label="供应商电话" prop="Phone">
            <el-input
              v-model="form.Phone"
              placeholder="请输入供应商名电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="ContactName">
            <el-input
              v-model="form.ContactName"
              placeholder="请输入供应商联系人"
            ></el-input>
          </el-form-item>
          <el-form-item label="供应商Email" prop="Email">
            <el-input
              v-model="form.Email"
              placeholder="请输入供应商名Email"
            ></el-input>
          </el-form-item>

          <el-form-item label="供应商状态" prop="States">
            <el-radio-group v-model="form.States">
              <el-radio :label="true">启用</el-radio>
              <el-radio :label="false">停用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注" prop="Remarks">
            <el-input
              type="textarea"
              v-model="form.Remarks"
              placeholder=""
              rows="3"
              resize="none"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="所属角色">
            <el-select
              v-model="form.RoleIdList"
              placeholder="请选择角色"
              multiple
              filterable
            >
              <el-option
                v-for="item in RoleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.RoleName"
                >{{ item.RoleName }}</el-option
              >
            </el-select>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import SelectDicValue from '@/components/DicValue/SelectDicValue.vue'
import Token from '@/utils/cache/TokenCache.js'
export default {
  data() {
    return {
      title: '',
      loading: false,
      token: 'Bearer ' + Token.getToken(),
      RoleList: [],
      form: {
        Code: '',
        Name: '',
        Type: '',
        Phone: '',
        ContactName: '',
        Email: '',
        States: true,
        Remarks: '',
      },
      rules: {
        Name: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' },
        ],
        // ContactName: [{ required: true, message: "请输入供应商联系人", trigger: "blur" }],
        Type: [
          { required: true, message: '请选择供应商类型', trigger: 'change' },
        ],
        States: [
          { required: true, message: '请选择供应商类型', trigger: 'change' },
        ],
        // Phone: [{ required: true, message: "请输入供应商名电话", trigger: "blur" }],
      },
      drawer: false,
    }
  },
  props: {},
  components: { SelectDicValue },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.status == 'done') {
        this.form.HeadImg = res.url

        console.log(this.form.HeadImg)
      } else {
        this.$notify.error(res.Msg)
      }
    },
    getRoleList() {
      this.$http
        .post('/Base_Manage/Base_Role/GetDataList', {
          SortField: 'CreateTime',
          SortType: 'Desc',
        })
        .then((resJson) => {
          if (resJson.Success) {
            this.RoleList = resJson.Data
          }
        })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        this.loading = true
        this.$http
          .post('/PB/PB_Supplier/SaveData', this.form)
          .then((resJson) => {
            this.loading = false

            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}) {
      this.drawer = true
      // this.getRoleList();
      this.form = {
        Code: '',
        Name: '',
        Type: '',
        Phone: '',
        ContactName: '',
        Email: '',
        States: true,
        Remarks: '',
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/PB/PB_Supplier/GetTheData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
